import { __decorate } from "tslib";
import { __metadata } from "tslib";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try {
            step(generator.next(value));
        }
        catch (e) {
            reject(e);
        } }
        function rejected(value) { try {
            step(generator["throw"](value));
        }
        catch (e) {
            reject(e);
        } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function () { if (t[0] & 1)
            throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function () { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f)
            throw new TypeError("Generator is already executing.");
        while (_)
            try {
                if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done)
                    return t;
                if (y = 0, t)
                    op = [op[0] & 2, t.value];
                switch (op[0]) {
                    case 0:
                    case 1:
                        t = op;
                        break;
                    case 4:
                        _.label++;
                        return { value: op[1], done: false };
                    case 5:
                        _.label++;
                        y = op[1];
                        op = [0];
                        continue;
                    case 7:
                        op = _.ops.pop();
                        _.trys.pop();
                        continue;
                    default:
                        if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                            _ = 0;
                            continue;
                        }
                        if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) {
                            _.label = op[1];
                            break;
                        }
                        if (op[0] === 6 && _.label < t[1]) {
                            _.label = t[1];
                            t = op;
                            break;
                        }
                        if (t && _.label < t[2]) {
                            _.label = t[2];
                            _.ops.push(op);
                            break;
                        }
                        if (t[2])
                            _.ops.pop();
                        _.trys.pop();
                        continue;
                }
                op = body.call(thisArg, _);
            }
            catch (e) {
                op = [6, e];
                y = 0;
            }
            finally {
                f = t = 0;
            }
        if (op[0] & 5)
            throw op[1];
        return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { Component, Input, Output, EventEmitter } from '@angular/core';
import VoucherService from "@api/services/voucher/voucher-service";
import { AppState } from '../../../app.service';
import { TrackingError } from '@api/services/tracking';
export var VoucherState = /*@__PURE__*/ (function (VoucherState) {
    VoucherState[VoucherState["Unknown"] = 0] = "Unknown";
    VoucherState[VoucherState["Unavailable"] = 1] = "Unavailable";
    VoucherState[VoucherState["Available"] = 2] = "Available";
    VoucherState[VoucherState["Error"] = 3] = "Error";
    VoucherState[VoucherState["Success"] = 4] = "Success";
    return VoucherState;
})({});
var State = /*@__PURE__*/ (function () {
    function State(type) {
        this.type = type;
    }
    return State;
}());
export { State };
var VoucherCodeComponent = /*@__PURE__*/ (function () {
    /**
     * public modifiers
     */
    function VoucherCodeComponent(appState) {
        this.appState = appState;
        this.voucherStateChanged = new EventEmitter();
        /**
         * Set our default values
         */
        this.inputPlaceHolder = "Ihr Gutscheincode";
        this.voucherCode = "";
        // Store a reference to the enum
        this.voucherStateValues = VoucherState;
        //this.state = new State(VoucherState.Unavailable)
    }
    //public state: State;
    VoucherCodeComponent.prototype.setState = function (type) {
        // this.voucherState = type;
        this.voucherStateChanged.emit(type);
    };
    VoucherCodeComponent.prototype.getVoucherAvailable = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, VoucherService.checkVoucherCodeAvailable()];
            });
        });
    };
    VoucherCodeComponent.prototype.validateVoucherCode = function (code) {
        return __awaiter(this, void 0, void 0, function () {
            var valid, trackingMessage, tracking;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, VoucherService.validateVoucherCode(code)];
                    case 1:
                        valid = _a.sent();
                        tracking = new TrackingError();
                        if (valid) {
                            this.setState(VoucherState.Success);
                            trackingMessage = 'Voucher applied successfully';
                        }
                        else {
                            this.setState(VoucherState.Error);
                            trackingMessage = 'Coupon code unknown';
                        }
                        tracking
                            .setEventName('notification')
                            .setType('notification')
                            .setMessage(trackingMessage)
                            .setCode('voucher code validation')
                            .track();
                        return [2 /*return*/];
                }
            });
        });
    };
    VoucherCodeComponent.prototype.resetVoucher = function () {
        var available = this.getVoucherAvailable();
        this.voucherCode = "";
        if (this.voucherState === VoucherState.Error && available) {
            this.setState(VoucherState.Available);
        }
        else if (this.voucherState === VoucherState.Error && !available) {
            this.setState(VoucherState.Unavailable);
        }
    };
    VoucherCodeComponent.prototype.ngOnInit = function () {
        return __awaiter(this, void 0, void 0, function () {
            var voucherAvailable;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!(this.voucherState === VoucherState.Unknown))
                            return [3 /*break*/, 2];
                        voucherAvailable = void 0;
                        return [4 /*yield*/, this.getVoucherAvailable()];
                    case 1:
                        voucherAvailable = _a.sent();
                        if (voucherAvailable) {
                            this.setState(VoucherState.Available);
                        }
                        else {
                            this.setState(VoucherState.Unavailable);
                        }
                        _a.label = 2;
                    case 2: return [2 /*return*/];
                }
            });
        });
    };
    return VoucherCodeComponent;
}());
export { VoucherCodeComponent };



//////////////////
// WEBPACK FOOTER
// ./app/bundles/enterprise-shop/src/app/modules/basket-overview/voucher-code/voucher-code.component.ts
// module id = null
// module chunks = 